import jQuery from 'jquery';

const globalJQuery =
  typeof window.jQuery === 'function' && window.jQuery.fn ? window.jQuery : jQuery;
window.$ = globalJQuery;
window.jQuery = globalJQuery;
